module.exports = __webpack_public_path__ + "static/media/multiplex25.6858bc45.png";